import { render, staticRenderFns } from "./myReserve.vue?vue&type=template&id=81af26b2&scoped=true&"
import script from "./myReserve.vue?vue&type=script&lang=js&"
export * from "./myReserve.vue?vue&type=script&lang=js&"
import style0 from "./myReserve.vue?vue&type=style&index=0&id=81af26b2&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "81af26b2",
  null
  
)

export default component.exports